import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { ScheduleType } from 'types/schedule'

const useHandleScheduledGeneration = (
  setScheduledGeneration: Dispatch<SetStateAction<boolean>>,
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>
): ((event: ChangeEvent<HTMLInputElement>) => void) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.value === 'scheduled') {
        setScheduledGeneration(true)
      } else {
        setDailySchedules((prevState) => {
          const nextState = prevState[0]
          if (!nextState) return []
          nextState.default_stocks = [{ pickupable_time: '', stock: 0 }]
          nextState.days_of_week = []
          return [nextState]
        })
        setScheduledGeneration(false)
      }
    },
    [setScheduledGeneration, setDailySchedules]
  )
}

export default useHandleScheduledGeneration
